import React from "react";
import LoadingBar from "react-top-loading-bar";

const Loader = (props) => {
  return (
    <div>
      <LoadingBar color="#f11946" progress={props.progress} />
    </div>
  );
};

export default Loader;
